'use client';

import { useEffect } from 'react';

import { getDefaultCategories } from '@libs/algolia';
import { PageType, useFeaturedBrand, usePageLayout, useSearchPage } from '@libs/common-next';

import { getCustomerObject, getPageData, getProductObject } from '../../helpers/digitalData';
import type { DigitalDataObject, DigitalDataProps } from './types';

declare const window: Window &
    typeof globalThis & {
        digitalData: DigitalDataObject;
    };

export function DigitalData({ product, categories }: DigitalDataProps) {
    const { pageType: appPageType, user, userData } = usePageLayout();
    const isFeaturedBrand = useFeaturedBrand();
    const isSearchPage = useSearchPage();

    const searchPageType = isFeaturedBrand
        ? 'Brand Landing Page'
        : categories?.length && !isSearchPage
          ? 'Category Landing'
          : 'Product List';

    const currentPageType = appPageType === PageType.PLP ? searchPageType : 'Product Details';

    useEffect(() => {
        const productCategories = product ? getDefaultCategories(product).map(cat => cat.name.default) : [];
        const productData = product ? getProductObject(product, productCategories) : {};

        const customerData = getCustomerObject(user, userData);

        const pageData = getPageData(categories ?? productCategories, currentPageType);

        window.digitalData = {
            ...window.digitalData,
            ...customerData,
            ...pageData,
            ...productData,
        };
    }, [product, categories, currentPageType, user, userData]);

    return '';
}
